import * as mttTypes from '@/store/mutationTypes'
// import {devMntAPI} from '@/api/restfulAPI'

const state = {
  groupInfos: []
}

const getters = {
  devInfos: state => {
    return state.groupInfos
  }
}

const mutations = {
  [mttTypes.GET_GROUP_INFOS] (state, groupInfos) {
    state.groupInfos = groupInfos
  }
}

const actions = {
  getGroupInfos ({commit, state}) {
    // let groupInfos = []
    // devMntAPI.getGroupInfos(null, null, null).then(data => {
    //   groupInfos = data.data
    //   commit(mttTypes.GET_GROUP_INFOS, groupInfos)
    // }).catch(error => {
    //   console.log(error)
    // })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/groupMnt.js